import { NewEmail } from "../pages/new-email.component"
import { NewPassword } from "../pages/new-password.component"

export const dialogMap = new Map()
dialogMap.set("EMAIL", NewEmail)
dialogMap.set("PASSWORD", NewPassword)